export default __webpack_public_path__ + "static/01 - Demian Ferrari-22832b14325ea990d475a80f920b050d.png";